import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/Rx';

import { Migalha } from 'models/migalha';

@Injectable()
export class MigalhasService {

  private migalhasObs$: BehaviorSubject<Migalha[]>;
  private migalhas: Migalha[];
  private siteMap: Migalha[];

  iniciar(siteMap: Migalha[]): BehaviorSubject<Migalha[]> {
    if (!siteMap || siteMap.length <= 0) {
      return;
    }
    this.limparVarsControle();
    this.siteMap = siteMap;
    this.definirMigalhas(undefined);
    this.migalhasObs$ = new BehaviorSubject(this.migalhas);
    return this.migalhasObs$;
  }

  novaUrl(url: string) {
    if (!url) {
      return;
    }
    if (this.definirMigalhas(url)) {
      this.migalhasObs$.next(this.migalhas);
    }
  }

  private limparVarsControle() {
    this.siteMap = undefined;
    this.migalhas = undefined;
    if (this.migalhasObs$) {
      this.migalhasObs$.complete();
    }
    this.migalhasObs$ = undefined;
  }

  private definirMigalhas(url: string): boolean {
    // valor inicial
    if (!url) {
      if (this.siteMap.length === 1) {
        this.migalhas = [this.siteMap[0]];
      } else {
        this.migalhas = [];
      }
      return true;
    }

    const { encontrou, acumulador } = this.navegarSitemapRecursivo(url, this.siteMap);
    if (encontrou) {
      this.migalhas = acumulador;
      return true;
    }

    return false;
  }


  private navegarSitemapRecursivo(
    url: string,
    migalhas: Migalha[],
    acumulador: Migalha[] = [],
  ): { encontrou: boolean, acumulador: Migalha[] } {

    for (let i = 0; i < migalhas.length; i++) {
      const migalha = migalhas[i];

      // tem que fazer cópia sempre, para não afetar outras chamadas recursivas
      const acumuladorTmp = [...acumulador, migalha];
      if (url === migalha.link) {
        return { encontrou: true, acumulador: acumuladorTmp };
      }

      if (migalha.submenu) {
        const { encontrou: fim, acumulador: novoAcumulador } =
          this.navegarSitemapRecursivo(url, migalha.submenu, acumuladorTmp);
        if (fim) {
          return { encontrou: fim, acumulador: novoAcumulador };
        }
      }
    }

    return { encontrou: false, acumulador };
  }
}
